import { render, staticRenderFns } from "./DocuSignSignersTab.vue?vue&type=template&id=17955ce8&"
import script from "./DocuSignSignersTab.vue?vue&type=script&lang=ts&"
export * from "./DocuSignSignersTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports